import { useState } from "react";
import { Col, Row } from "../../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../../Buttons/MainButton";
import Title from "../../../Title/Title";
import logo from "../../../../images/Damas_univ.png";
import Add from "../../../Buttons/Add";
import Pagination from "../../../pagination/Pagination (1)";
import PopUpDelete from "../../../PopUps/PopUpDelete (1)";
import { useDelete, useFetch } from "../../../../ApiS";
import Loader from "../../../Loader";

import { RiEditBoxFill } from "react-icons/ri";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import Table, { TableOperation } from "../../../Table";
import { usePopUpsStore } from "../../../../store/PopUpStore";

interface Teachers {
  id: string | number;
  academic_rank: string;
  mobile: string | number;
  email: string;
}

export default function TeachingStaff() {
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();

  const { deleteItem } = useDelete(
    () => {},
    () => {}
  );

  const { data, isLoading } = useFetch("admin/doctors", "admin/doctors");

  const operations: TableOperation[] = [
    {
      name: "show",
      icon: FaEye,
      link: true,
      onClick: () => {
        console.log("View");
      },
    },
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: true,
      onClick: () => {
        console.log("edit");
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Row>
        <Col lg={4}>
          <Title title=" الكادر التدريسي " />
        </Col>
      </Row>
      <Row justify="center">
        <Table<Teachers>
          tableHeads={[
            "الرقم",
            " أيميل الدكتور",
            " الترتيب الاكاديمي ",
            " رقم الدكتور ",
            " العمليات",
          ]}
          tableBody={data?.data?.data}
          keys={["id", "email", "academic_rank", "mobile"]}
          operations={operations}
          className="lg:min-w-[100px] md:min-w-[50px]"
        />
        {data?.data?.data?.length > 0 && (
          <Pagination pageCount={data?.data?.last_page} />
        )}

        <PopUpDelete
          text="هل أنت متأكد من حذف هذا الدكتور؟"
          onClickDelete={() => deleteItem(`admin/doctors/${popUpDelete[0]}`)}
        />
      </Row>
      <Add link="add" />
    </>
  );
}
